module.exports = __webpack_public_path__ + "img/chanquanguanli.e280618a.png";